// ShapeProgress.js

import React from "react";
import styled from "styled-components";

const ProgressBarContainer = styled.div`
    width: 100%;
    height: 20px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #f2eff0;
    position: relative;
`;

const ProgressBarContainerBar = styled.div`
    width: ${props => props.progress}%;
    height: 20px;
    border-radius: 10px;
    position: absolute;
    ${props => props.bgColor && `background-color: ${props.bgColor};`}
    left: 0;
    top: 0;
    transition: width 0.3s ease-in-out;
`;

const ProgressBar = ({ progress, bgColor }) => {
    return (
      <ProgressBarContainer>
        <ProgressBarContainerBar bgColor={bgColor} progress={progress}></ProgressBarContainerBar>
      </ProgressBarContainer>
    );
};

const ShapeProgress = ({ progress, bgColor }) => {
    return (
      <>
        <ProgressBar bgColor={bgColor} progress={progress} />
        {/* <div>Progress: {Math.round(progress)}%</div> */}
      </>
    );
};

export default ShapeProgress;
